import LineInfoCircleIcon from 'components/Luxkit/Icons/line/LineInfoCircleIcon'
import BodyTextBlock from 'components/Luxkit/TextBlocks/BodyTextBlock'
import ModalContext from 'contexts/ModalContext'
import React, { useContext } from 'react'
import CarHireInsuranceModal from './CarHireInsuranceUpgradeModal/CarHireInsuranceModal'
import Clickable from 'components/Common/Clickable'

interface Props {
  isEnhancedProtectionSelected: boolean
  offer: App.CarHireOffer
  pickUpDate: string
  dropOffDate: string
}

function CarHireInsuranceText(props: Props) {
  const { isEnhancedProtectionSelected, offer, pickUpDate, dropOffDate } = props

  const showModal = useContext(ModalContext)
  const onTextClick = () => {
    showModal(<CarHireInsuranceModal isEnhancedProtectionSelected={isEnhancedProtectionSelected} pickUpDate={pickUpDate} dropOffDate={dropOffDate} offer={offer} />)
  }

  return <Clickable onClick={onTextClick}>
    <BodyTextBlock
      variant="medium"
      colour={isEnhancedProtectionSelected ? 'highlight-secondary' : 'primary'}
      weight="bold"
      endIcon={<LineInfoCircleIcon colour="neutral-one" size="XS" />}
    >
      {isEnhancedProtectionSelected ? 'Enhanced Protection' : 'Limited Protection'}
    </BodyTextBlock>
  </Clickable>
}

export default CarHireInsuranceText
